import { render, staticRenderFns } from "./TableService.vue?vue&type=template&id=26606b0a"
import script from "./TableService.vue?vue&type=script&lang=js"
export * from "./TableService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports